<template>
<!-- iframe  -->
<div>
    <iframe :src="pdfUrl" width="100%" height="500" frameborder="0"></iframe>
</div>
</template>

<script>
export default {
    data() {
        return {
            url: '/web/viewer.html?file=',
            file: ''
        }
    },
    computed: {
        pdfUrl() {
            return this.url + this.file
        }
    },
    mounted() {
        this.file = this.$route.query.file;
    },
    watch: {
        '$route'() {
            this.file = this.$route.query.file;
        }
    }
}
</script>

<style lang="scss" scoped>
iframe {
    width: 100vw;
    height: 100vh;
}
</style>
